import { Tab } from "@headlessui/react";
import type { PropsWithChildren } from "react";

const VideoTab = ({
	children,
	id,
}: PropsWithChildren<{
	id: string;
}>) => {
	return (
		<div>
			<Tab
				id={id}
				className="scroll-m-56 whitespace-nowrap rounded-full border border-transparent bg-slate-100 px-3 py-1 font-medium transition-all data-[selected]:border-inherit data-[selected]:bg-white data-[selected]:shadow data-[selected]:shadow-slate-100 dark:bg-slate-700/50 dark:data-[selected]:bg-slate-700 dark:data-[selected]:shadow-slate-900"
			>
				{children}
			</Tab>
		</div>
	);
};

export default VideoTab;
